export const adventures = [
  {
    name: "Brahma Tal Trek",
    subtitle: "Frozen lake at the foot of Mt. Trishul & Nanda Ghunti",
    type: "Winter Trek",
    difficulty: "Moderate",
    elevation: "12,500 ft",
    elevationMetric: "3,810 m",
    location: "Lohajung, Uttarakhand",
    origin: "Bengaluru, Karnataka",
    startDate: "Dec 23, 2021",
    endDate: "Jan 2, 2022",
    duration: "11 Days",
    distance: "35 km",
    image: "/BrahmaTal.JPG",
    videoUrl: "https://www.youtube.com/watch?v=we-np9iSZK8",
    tags: ["High Altitude", "Snow Camp", "Himalaya", "Winter", "Lake"],
  }
]
